export default "__VITE_ASSET__5a12227b__"